export enum EmailOrderBy {
	To = 'To',
	Subject = 'Subject',
	CreatedDate = 'CreatedDate',
	SentDate = 'SentDate',
}
